import React from "react";
import { Challenge } from "../ChallengesPage";
import Button from "../../Button";
import moment from "moment";
import Popup from "../../common/Popup";
import styled from "styled-components";

const Content = styled.div`
    text-align: center;
`;

const Title = styled.h2`
    color: var(--text-primary) !important;
    font-family: var(--ff-title);
    font-size: 2.5rem !important;
    margin-bottom: 1rem !important;

    body.theme-traditional & {
        text-transform: uppercase;
    }
    
    body.theme-market & {
        color: var(--page-bg) !important;
        font-weight: 900;
    }
`;
const Icon = styled.span`
    display: block;
    font-size: 2.5rem;
    margin: 1rem 0;
}
`;

interface Props {
    challenge: Challenge;
    userFirstName: string;
    onClose: () => void;
}

const ChallengeCompletedDetail: React.FC<Props> = ({ challenge, userFirstName, onClose }) => {
    const date = moment(challenge.expiry).format('DD [de] MMMM [de] YYYY');

    return (
        <Popup isOpen={true} onClose={onClose}>
            <Content>
                <Title>Recompensa</Title>

                <Icon>🏆</Icon>

                <p>
                    <strong>¡Felicidades {userFirstName}!</strong>
                </p>

                <p>{challenge.completion_text}</p>
                
                <div className="d-block d-md-none">
                    <Button to="/usuario/loop/tarjeta#mis-beneficios">Ir a mis beneficios</Button>
                </div>
            </Content>
        </Popup>
    );
};

export default ChallengeCompletedDetail;